import { z } from 'zod';
import {
  CYO_ROUTE,
  PRECHECKOUT_PLAN_ROUTE,
  ROUTE_SIGN_UP,
  ROUTE_QUIZ_BUILDING,
} from '@hungryroot/routes';
import { allQuizRoutes } from '../defs/routes';

const ROUTE_CHECKOUT_SHIPPING = '/checkout/shipping/';
const ROUTE_HOMEPAGE = '/';
const ROUTE_CHECKOUT_PAYMENT = '/checkout/payment/';

const preSignUpRoutes = [
  ROUTE_HOMEPAGE,
  ROUTE_QUIZ_BUILDING,
  ROUTE_SIGN_UP,
  ...allQuizRoutes,
] as const;

export const postSignUpRoutes = [
  CYO_ROUTE,
  ROUTE_CHECKOUT_SHIPPING,
  ROUTE_CHECKOUT_PAYMENT,
  PRECHECKOUT_PLAN_ROUTE,
] as const;

// All of the funnel routes
// This is not an ordered list
// Its just a list of all the routes in the funnel
const funnelRoutes = [...preSignUpRoutes, ...postSignUpRoutes] as const;

export type AllFunnelRoutes = (typeof funnelRoutes)[number];

export const funnelRoutesSchema = z.enum(funnelRoutes);
